var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.theme,attrs:{"id":"app"}},[_c('AppHeader',{attrs:{"room-name":_vm.roomName},on:{"theme-change":_vm.setTheme}}),_c('main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }